module.exports = __webpack_public_path__ + "media/images/icon__unlocked@2x-59f92a307a336582f572dfc23d6c8bae.png";